"use client";

import { useContext } from "react";

import {
  NavigationActionInterceptorContext,
  type NavigationActionInterceptorState,
} from "../contexts/NavigationActionInterceptorContext";

/**
 * Returns the navigation action interceptor context.
 * Throws if used outside of a `NavigationActionInterceptorProvider`.
 */
export const useNavigationActionInterceptor =
  (): NavigationActionInterceptorState => {
    const context = useContext(NavigationActionInterceptorContext);
    if (!context) {
      throw new Error(
        "useNavigationActionInterceptor must be used within a NavigationActionInterceptorProvider",
      );
    }
    return context;
  };

/**
 * Returns the navigation action interceptor context, or `undefined`
 * if no provider is present. Used by `useActions` so the interceptor
 * system is opt-in.
 */
export const useMaybeNavigationActionInterceptor = ():
  | NavigationActionInterceptorState
  | undefined => {
  return useContext(NavigationActionInterceptorContext);
};
